import { useEffect, useState } from 'react';
import BaseDirectories from '../../../base directories/BaseDirectories';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {
  Autoplay,
  EffectCoverflow,
  FreeMode,
  Navigation,
  Pagination,
} from 'swiper';
import Confetti from 'react-confetti';

const windowSize = {
  width: 1024,
  height: 700,
};

const AnnHeroSection = () => {
  const [useWindowSize, setUseWindowsSize] = useState(windowSize);
  const { width, height } = useWindowSize;
  useEffect(() => {
    setInterval(() => {
      setUseWindowsSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }, 500);
  }, []);
  return (
    <section className="landing-page-hero d-flex flex-column relative">
      <Confetti width={width} height={height} gravity={0.1} />
      <div className="absolute w-100 d-flex top-0">
        <img
          src={`${BaseDirectories.IMAGES_DIR}/ann/line.png`}
          alt=""
          className="w-100"
        />
      </div>
      <div
        className="anniversary-hero"
        style={{
          backgroundImage: `url(${BaseDirectories.IMAGES_DIR}/ann/confetti_bg.png)`,
        }}>
        <div
          className="outer-bg d-flex flex-column flex-lg-row justify-content-center align-items-center"
          style={{
            backgroundImage: `url(${BaseDirectories.IMAGES_DIR}/ann/bg.png)`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}>
          {/* Left */}
          <div className="mb-4 mb-lg-0 text-center">
            <img
              src={`${BaseDirectories.IMAGES_DIR}/ann/logo.png`}
              alt="Anniversary Hero"
            />
          </div>

          {/* Right */}
          <div className="flex-column align-content-end text-center text-lg-start">
            <div className="d-flex justify-content-center justify-content-lg-end">
              <div className="me-2">
                <img
                  src={`${BaseDirectories.IMAGES_DIR}/ann/img1.png`}
                  alt=""
                />
              </div>
              <div className="mt-4">
                <img
                  src={`${BaseDirectories.IMAGES_DIR}/ann/img2.png`}
                  alt=""
                />
              </div>
            </div>

            <div className="hero-text mt-3">
              <span className="d-flex align-items-end ">
                <span
                  className="  fst-italic"
                  style={{
                    fontSize: '4rem',
                    color: '#00B894',
                    lineHeight: '1',
                    marginBottom: '-0.8rem',
                    fontWeight: '900',
                    textShadow: '6px 3px 6px rgba(0, 0, 0, 0.2)',
                  }}>
                  4
                </span>
                <div style={{ marginTop: '-1rem' }}>
                  <span className="fs-2 fw-semibold ms-2">
                    Years of Empowering
                  </span>
                </div>
              </span>
              <div
                className="fw-bolder fs-1 text-primary-blue "
                style={{ marginTop: '-0.5rem', marginLeft: '5rem' }}>
                Women, Farmers and MSMEs
              </div>
            </div>

            <div className="d-flex justify-content-center justify-content-lg-start mt-3">
              <span className="me-2">
                <img
                  src={`${BaseDirectories.IMAGES_DIR}/ann/img3.png`}
                  alt=""
                />
              </span>
              <span className="me-2 " style={{ marginTop: '6rem' }}>
                <img
                  src={`${BaseDirectories.IMAGES_DIR}/ann/img4.png`}
                  alt=""
                />
              </span>
              <span>
                <img
                  src={`${BaseDirectories.IMAGES_DIR}/ann/img5.png`}
                  alt=""
                />
              </span>
            </div>
          </div>
        </div>

        <div className="absolute w-100 d-flex bottom-0">
          <img
            src={`${BaseDirectories.IMAGES_DIR}/ann/line.png`}
            alt=""
            className="w-100"
          />
        </div>
      </div>
      <div className="marque-container">
        <div className="hero-img">
          <Swiper
            className="swiper-container"
            effect={'coverflow'}
            grabCursor={true}
            centeredSlides={true}
            loop={true}
            freeMode={true}
            slidesPerView={'auto'}
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 100,
              modifier: 2.5,
            }}
            pagination={{ el: 'swiper-pagination', clickable: true }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            modules={[
              EffectCoverflow,
              Autoplay,
              FreeMode,
              Pagination,
              Navigation,
            ]}>
            <SwiperSlide>
              <img
                src={`${BaseDirectories.IMAGES_DIR}/SDG_1.png`}
                alt="slide_image"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={`${BaseDirectories.IMAGES_DIR}/SDG_2.png`}
                alt="slide_image"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={`${BaseDirectories.IMAGES_DIR}/SDG_3.png`}
                alt="slide_image"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={`${BaseDirectories.IMAGES_DIR}/SDG_4.png`}
                alt="slide_image"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={`${BaseDirectories.IMAGES_DIR}/SDG_5.png`}
                alt="slide_image"
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default AnnHeroSection;
